module.exports = __webpack_public_path__ + "static/img/ios1.1.504f8d54.jpg";